import * as React from "react";
import AsyncSelect from 'react-select/async';
import axios from "axios";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";

type suburbObject = {
    value: string,
    label: string,
    postcode: string,
    suburbName: string
}

const url = (window as any).c4k.urls.locationAutocomplete

export const CocSuburbAutocomplete = () => {

    const { state, HandleSelectSuburb } = React.useContext(CostOfCareCalculatorContext);

    // Filter logic
    const GetSuggestions = (value) => {
        const inputValue = value.trim().toLowerCase();

        let queryUrl = url + "?term=" + inputValue;

        if (inputValue.length > 2) {

            return new Promise<Array<suburbObject>>((resolve, reject) => {
                axios.get(queryUrl).then((response: any) => {

                    // Format to an array that matches the value label structure
                    let results = response.data.map(suburb => {
                        return {
                            value: suburb.key,
                            label: suburb.label,
                            postcode: suburb.postcode,
                            suburbName: suburb.suburbName
                        }
                    })
                    resolve(results)
                })
                    .catch(error => {
                        console.log('Suburb search error', error)
                    })
            })
        }
    };

    return (
        <AsyncSelect
            loadOptions={(option) => GetSuggestions(option)}
            onChange={(value) => HandleSelectSuburb(value)}
            className="h-10"
            placeholder="Please enter a postcode or suburb"
            value={!!state.suburbLabel ? { label: state.suburbLabel, value: state.suburbId } : null}
        />
    );
}